import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { Location } from "app/common/location";

import { CaseService } from "app/case/case.service"
import { Incident } from "app/shared/shared.module";
import { Subscription } from "rxjs/Rx";
import { BusyLoaderService } from "app/shared/components/busy-loader.service";

@Component({
	selector: 'app-case',
	templateUrl: './case.component.html',
	styleUrls: ['./case.component.css']
})
export class CaseComponent implements OnInit {

	SelectedLocation: Location;
	CaseListingLoading: boolean = false;
    CaseListingLimit: number = 25;
	CaseListingBracket: number = 0;

	CaseListingTypeFilter: string = 'All';

	List: boolean = true;
	Mine: boolean = false;

	sub: Subscription;
	sub2: Subscription;
    GettingCases: Subscription;

	Type: string;

    CaseListings: Array<Incident> = [];

    constructor(private route: ActivatedRoute, private caseService: CaseService, private busyLoaderService: BusyLoaderService ) {
		//console.log(route);
	}

	ngOnInit() {
		this.sub = this.route.data.subscribe(
            d => {
                this.Type = d.Type;
                this.GetCases(this.Type);
            }
		);
		this.sub2 = this.route.params.subscribe(
			d => this.CaseListingTypeFilter = d.assignment ? d.assignment.toUpperCase() : 'ALL'
		);
	}
	ngOnDestroy() {
		this.sub.unsubscribe();
        this.sub2.unsubscribe();
        this.GettingCases.unsubscribe();
    }

    GetCases(Status: string = "") {
        var __this = this;
        var ob = this.caseService.GetCases(Status);
        this.busyLoaderService.AddLoadingObservable(ob);
        this.GettingCases = ob.subscribe(
            data => {
                __this.CaseListings = data;
            }, err => {
                console.log(err);
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/app/case/list/case.component.ts